var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.show,"no-wrap":_vm.noWrap,"variant":"white","opacity":"0.8","blur":"2px","spinner-variant":"success"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }